module.exports = __webpack_public_path__ + "static/img/flowChart1.16019ea9.jpg";